import { getMeta } from '../data/appMeta';
import type { SqlDriver } from '../data/db/driver';

/** From the last sync: whether each budget's owner's Premium covers it (sync_access). */
export const ACCESS_PREMIUM_KEY = 'sync.accessPremium';

/**
 * Shared budgets (someone else is in them) that are read-only now: their
 * owner's Premium ended. For your own budget that is your Premium, known on
 * this device; for someone else's, what the server said at the last sync.
 * Everything stays readable, and pulling goes on; writes wait for renewal,
 * so the people in it never drift apart. A budget only you are in is never
 * read-only: without Premium it just stays on this device.
 */
export async function readOnlySpaces(db: SqlDriver, userId: string, ownPremium: boolean): Promise<Set<string>> {
  const stored = await getMeta(db, ACCESS_PREMIUM_KEY);
  const covered: Record<string, boolean> = stored ? JSON.parse(stored) : {};
  const shared = await db.all<{ id: string; owner: string }>(
    `SELECT s.id, s.owner_user_id AS owner FROM budget_spaces s
      WHERE s.deleted_at IS NULL
        AND (SELECT COUNT(*) FROM budget_members m WHERE m.space_id = s.id AND m.deleted_at IS NULL AND m.user_id IS NOT NULL) > 1`,
  );
  return new Set(shared.filter((s) => (s.owner === userId ? !ownPremium : covered[s.id] === false)).map((s) => s.id));
}
